import * as Types from './messaging_gql.generated';

import { gql } from 'graphql.macro';
export type MessageFragment = (
  { __typename?: 'MessageNode' }
  & Pick<Types.MessageNode, 'uuid' | 'conversationUuid' | 'senderUuid' | 'receiverUuid' | 'content' | 'sentAt' | 'readAt'>
  & { messageResources?: Types.Maybe<Array<Types.Maybe<(
    { __typename?: 'MessageResourceNode' }
    & Pick<Types.MessageResourceNode, 'uuid' | 'order' | 'meditationId' | 'programId' | 'companyAdditionalBenefitId'>
  )>>> }
);

export type CoachFragment = (
  { __typename?: 'CoachNode' }
  & Pick<Types.CoachNode, 'uuid' | 'firstName' | 'lastName' | 'avatar' | 'providerType' | 'providerSchedulingType' | 'psychiatristSubtype'>
);

export type MemberFragment = (
  { __typename?: 'MemberNode' }
  & Pick<Types.MemberNode, 'uuid' | 'firstName' | 'lastName' | 'avatar'>
);

export type ConversationFragment = (
  { __typename?: 'ConversationNode' }
  & Pick<Types.ConversationNode, 'uuid' | 'active' | 'createdAt'>
  & { coach?: Types.Maybe<(
    { __typename?: 'CoachNode' }
    & CoachFragment
  )>, member?: Types.Maybe<(
    { __typename?: 'MemberNode' }
    & MemberFragment
  )>, newestMessage?: Types.Maybe<(
    { __typename?: 'MessageNode' }
    & MessageFragment
  )> }
);

export const CoachFragmentDoc = gql`
    fragment coach on CoachNode {
  uuid
  firstName
  lastName
  avatar
  providerType
  providerSchedulingType
  psychiatristSubtype
}
    `;
export const MemberFragmentDoc = gql`
    fragment member on MemberNode {
  uuid
  firstName
  lastName
  avatar
}
    `;
export const MessageFragmentDoc = gql`
    fragment message on MessageNode {
  uuid
  conversationUuid
  senderUuid
  receiverUuid
  content
  sentAt
  readAt
  messageResources {
    uuid
    order
    meditationId
    programId
    companyAdditionalBenefitId
  }
}
    `;
export const ConversationFragmentDoc = gql`
    fragment conversation on ConversationNode {
  uuid
  active
  createdAt
  coach {
    ...coach
  }
  member {
    ...member
  }
  newestMessage {
    ...message
  }
}
    ${CoachFragmentDoc}
${MemberFragmentDoc}
${MessageFragmentDoc}`;